export type FormData = { verifyCode: number }

export type VerifyEmailDialogContentProps = {
  email: string
  uuid: string
  verificationFor: verificationForEnum
  onSuccess: () => void
}

export enum validateErrorEnum {
  'ExpiredToken' = 'Expired Token',
  'TooManyRequests' = 'Too Many Requests',
  'Unauthorized' = 'Unauthorized',
}

export enum verificationForEnum {
  investor = 'investor',
  broker = 'broker',
  purchaser = 'purchaser',
}
